import React, { useState, useEffect } from 'react';
import { Bell, BellOff, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { toast } from 'sonner';

const PushNotificationToggle = () => {
  const [permission, setPermission] = useState('default');
  const [loading, setLoading] = useState(false);
  const [supported, setSupported] = useState(false);

  useEffect(() => {
    // プッシュ通知がサポートされているか確認
    const isSupported = 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
    setSupported(isSupported);
    
    if (isSupported) {
      setPermission(Notification.permission);
    }
  }, []);

  const requestPermission = async () => {
    if (!supported) {
      toast.error('このブラウザはプッシュ通知に対応していません');
      return;
    }

    setLoading(true);
    try {
      const result = await Notification.requestPermission();
      setPermission(result);

      if (result === 'granted') {
        toast.success('通知が有効になりました');
        
        // テスト通知を送信
        if ('serviceWorker' in navigator) {
          const registration = await navigator.serviceWorker.ready;
          registration.showNotification('PRC勤怠', {
            body: '通知が正常に設定されました',
            icon: '/icons/icon-192x192.png',
            badge: '/icons/icon-72x72.png'
          });
        }
      } else if (result === 'denied') {
        toast.error('通知が拒否されました。ブラウザの設定から変更できます。');
      }
    } catch (error) {
      console.error('Permission request error:', error);
      toast.error('通知の設定に失敗しました');
    } finally {
      setLoading(false);
    }
  };

  if (!supported) {
    return (
      <div className="flex items-center gap-2 text-sm text-slate-500">
        <BellOff className="w-4 h-4" />
        <span>このブラウザは通知非対応</span>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <div className="flex-1">
        <div className="flex items-center gap-2">
          {permission === 'granted' ? (
            <>
              <Bell className="w-4 h-4 text-emerald-500" />
              <span className="text-sm text-emerald-500">通知: ON</span>
            </>
          ) : permission === 'denied' ? (
            <>
              <BellOff className="w-4 h-4 text-red-500" />
              <span className="text-sm text-red-500">通知: ブロック中</span>
            </>
          ) : (
            <>
              <BellOff className="w-4 h-4 text-slate-500" />
              <span className="text-sm text-slate-500">通知: OFF</span>
            </>
          )}
        </div>
      </div>
      
      {permission !== 'granted' && permission !== 'denied' && (
        <Button
          onClick={requestPermission}
          disabled={loading}
          variant="outline"
          size="sm"
          className="text-xs"
        >
          {loading ? (
            <Loader2 className="w-3 h-3 animate-spin" />
          ) : (
            '通知を有効にする'
          )}
        </Button>
      )}
      
      {permission === 'denied' && (
        <span className="text-xs text-slate-500">
          ブラウザ設定で変更
        </span>
      )}
    </div>
  );
};

export default PushNotificationToggle;
